import {Box, Typography} from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import {useKioskLang} from "../context/KioskSessionContext";

const STEP_KEYS = ["stepMenu", "stepCart", "stepPay", "stepDone"];

export default function KioskSteps({active = 0}) {
  const {tr} = useKioskLang();
  const STEPS = STEP_KEYS.map((key) => tr(key));
  return (
    <Box component="nav" aria-label="點餐進度" sx={{flex: "0 0 auto", px: 3, py: 1.25, display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#FBF6EE", borderBottom: "1px solid rgba(80,55,40,.08)"}}>
      {STEPS.map((label, index) => {
        const done = index < active;
        const current = index === active;
        return (
          <Box key={label} sx={{display: "flex", alignItems: "center"}}>
            {index > 0 && <Box sx={{width: 48, height: 3, mx: 1, borderRadius: 2, bgcolor: done || current ? "primary.main" : "rgba(80,55,40,.15)", transition: "background-color .3s"}}/>}
            <Box aria-current={current ? "step" : undefined} sx={{display: "flex", alignItems: "center", gap: .9, px: current ? 1.8 : .7, py: .55, borderRadius: 99, bgcolor: current ? "primary.main" : "transparent", transition: "all .3s", animation: current ? "kioskPop .35s ease" : "none"}}>
              <Box sx={{width: 30, height: 30, borderRadius: "50%", display: "grid", placeItems: "center", fontWeight: 900, fontSize: 16, bgcolor: current ? "rgba(255,255,255,.28)" : done ? "primary.main" : "rgba(80,55,40,.12)", color: current || done ? "#FFF" : "text.secondary"}}>
                {done ? <CheckRoundedIcon sx={{fontSize: 19}}/> : index + 1}
              </Box>
              <Typography sx={{fontSize: 17, fontWeight: 900, color: current ? "#FFF" : done ? "primary.main" : "text.secondary"}}>{label}</Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
